export const OBJECT_CATEGORIES = [
  { value: 'Aqua aerobik', text: 'form.category.aquaAerobics' },
  { value: 'Badminton', text: 'form.category.badminton' },
  { value: 'Basen', text: 'form.category.swimmingPool' },
  { value: 'Basen letni', text: 'form.category.outdoorPool' },
  { value: 'Bilard', text: 'form.category.billiards' },
  { value: 'Centrum Interaktywne', text: 'form.category.interactiveCenter' },
  { value: 'Cross Trening', text: 'form.category.crossTraining' },
  { value: 'Dart', text: 'form.category.dart' },
  { value: 'Deska Sup', text: 'form.category.supBoard' },
  { value: 'EMS', text: 'form.category.ems' },
  { value: 'Gokarty/Quady', text: 'form.category.gokartsQuads' },
  { value: 'Golf', text: 'form.category.golf' },
  { value: 'Grota solna', text: 'form.category.saltCave' },
  { value: 'Gry Zespołowe', text: 'form.category.teamSports' },
  { value: 'HYROX', text: 'form.category.hyrox' },
  { value: 'Indoor Cycling', text: 'form.category.indoorCycling' },
  { value: 'Jazda Konna', text: 'form.category.horseRiding' },
  { value: 'Joga', text: 'form.category.yoga' },
  { value: 'Kajaki', text: 'form.category.kayaking' },
  { value: 'Kolej Linowa', text: 'form.category.cableRailway' },
  { value: 'Kręgle', text: 'form.category.bowling' },
  { value: 'Lodowisko', text: 'form.category.iceRink' },
  { value: 'Nordic walking', text: 'form.category.nordicWalking' },
  { value: 'OCR', text: 'form.category.ocr' },
  { value: 'Padel', text: 'form.category.padel' },
  { value: 'Paintball', text: 'form.category.paintball' },
  { value: 'Park trampolin', text: 'form.category.trampolinePark' },
  { value: 'Park linowy', text: 'form.category.ropePark' },
  { value: 'Park rozrywki', text: 'form.category.amusementPark' },
  { value: 'Pickleball', text: 'form.category.pickleball' },
  { value: 'Pilates', text: 'form.category.pilates' },
  { value: 'Pole dance', text: 'form.category.poleDance' },
  { value: 'Reformer Pilates', text: 'form.category.reformerPilates' },
  { value: 'Rolletic', text: 'form.category.rolletic' },
  { value: 'Rower wodny', text: 'form.category.pedalBoat' },
  { value: 'Sala Zabaw', text: 'form.category.playroom' },
  { value: 'Sauna', text: 'form.category.sauna' },
  { value: 'Ścianka wspinaczkowa', text: 'form.category.climbingWall' },
  { value: 'Shuffleboard', text: 'form.category.shuffleboard' },
  { value: 'Siatkówka plażowa', text: 'form.category.beachVolleyball' },
  { value: 'Siłownia', text: 'form.category.gym' },
  { value: 'Skatepark', text: 'form.category.skatepark' },
  { value: 'Spinning', text: 'form.category.spinning' },
  { value: 'Squash', text: 'form.category.squash' },
  { value: 'Stok narciarski/Skipass', text: 'form.category.skiSlope' },
  { value: 'Strzelnica', text: 'form.category.shootingRange' },
  { value: 'Symulator Golfa', text: 'form.category.golfSimulator' },
  { value: 'Symulator Narciarski', text: 'form.category.skiSimulator' },
  { value: 'Sztuki walki', text: 'form.category.martialArts' },
  { value: 'Taniec', text: 'form.category.dance' },
  { value: 'Tenis stołowy', text: 'form.category.tableTennis' },
  { value: 'Tenis ziemny', text: 'form.category.tennis' },
  { value: 'Tlenoterapia', text: 'form.category.oxygenTherapy' },
  { value: 'Vacu Well', text: 'form.category.vacuWell' },
  { value: 'Wake Park', text: 'form.category.wakePark' },
  { value: 'Wrotki', text: 'form.category.rollerskating' },
  { value: 'Zajęcia fitness', text: 'form.category.fitnessClasses' },
  { value: 'Zumba', text: 'form.category.zumba' },
  { value: 'Inne', text: 'form.category.other' },
]
